<!-- App Copyright 2022 Rebecca L Beaudet -->
<script lang="ts">
  import Footer from './Navigation/Footer.svelte';
  import TopNav from './Navigation/TopNav.svelte';
  import { getProfile } from './Persistence/profileDb';
  import { Router, Route } from 'svelte-routing';
  import Home from './Pages/Home.svelte';
  import { navPages, pageContent } from './language/pageContent';
  import GenericPage from './Pages/GenericPage.svelte';
  import PdVideos from './Pages/PDVideos.svelte';

  getProfile();

  export let url = '';
</script>

<Router {url}>
  <TopNav />
  <main>
    <Route path="learn"><PdVideos /></Route>
    {#each pageContent as page}
      <Route path={page.path}><GenericPage content={page} /></Route>
    {/each}
    {#each navPages as page}
      <Route path={page.path}><GenericPage content={page} /></Route>
    {/each}
    <Route path="/*"><Home /></Route>
  </main>
  <Footer />
</Router>
